import script from "./NewsAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsAdd.vue?vue&type=script&setup=true&lang=js"

import "./NewsAdd.vue?vue&type=style&index=0&id=fc92e676&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc92e676"]])

export default __exports__